import { Navigate, useParams } from 'react-router-dom'

import { paths } from './paths'

/**
 * Maps `/organizations/...` to `/workspaces/...` for old bookmarks.
 */
export const LegacyOrganizationRedirect = () => {
  const { id, tab } = useParams<{ id: string; tab?: string }>()

  if (!id) {
    return <Navigate to={paths.workspaces.root} replace />
  }

  const target = tab
    ? paths.workspaces.detailsTab(id, tab)
    : paths.workspaces.details(id)

  return <Navigate to={target} replace />
}
